export const StreamProvider = {
    ZATTOO: 'zattoo',
    RAKUTEN: 'rakuten_tv',
};
